// extracted by mini-css-extract-plugin
module.exports = {"OrderedList":"OrderedList_OrderedList__3noMv","list":"OrderedList_list__MA_xn","item":"OrderedList_item__zOVK5","paragraph":"OrderedList_paragraph__ZdZzD"};